import { ColDef } from '@ag-grid-community/core';

/**
 * Updates headerTooltip for columns with duplicate effective names.
 * If a name is duplicated, all columns with that name get a warning tooltip; otherwise, '' (empty string).
 * @param columnDefs The current column definitions
 * @param headerState The current header state object
 * @returns New column definitions with updated headerTooltip
 */
export function updateDuplicateHeaderTooltips(
  columnDefs: ColDef[],
  headerState: Record<string, { renamed: boolean; renamedValue: string }>
): { columnDefs: ColDef[]; hasDuplicate: boolean } {
  // Build a map of effective header names (taking into account renames)
  const nameToColIds: Record<string, string[]> = {};

  columnDefs.forEach((col) => {
    const colId = col.colId;

    if (!colId) return;
    const state = headerState[colId];
    let effectiveName = colId;

    if (state?.renamed) {
      effectiveName = state.renamedValue;
    }

    if (!nameToColIds[effectiveName]) {
      nameToColIds[effectiveName] = [];
    }

    nameToColIds[effectiveName].push(colId);
  });

  const defaultColumnColIds = ['type', 'program', 'project'];

  // Update tooltips for all columns
  const updatedColumnDefs = columnDefs.map((col) => {
    const colId = col.colId;

    if (!colId || defaultColumnColIds.includes(colId)) return col;
    const state = headerState[colId];
    let effectiveName = colId;

    if (state?.renamed) {
      effectiveName = state.renamedValue;
    }

    const count = nameToColIds[effectiveName]?.length || 1;
    let tooltip = '';

    if (effectiveName === '') {
      tooltip = 'Attribute name is required';
    }

    if (count > 1) {
      tooltip = `Attribute name must be unique. (${count} columns with this name)`;
    }

    return {
      ...col,
      // headerClass: () => (tooltip ? ['!px-2', '!py-0', 'ag-header-warning'] : ['!px-2', '!py-0']),
      headerTooltip: tooltip,
    };
  });

  const hasDuplicate = Object.values(nameToColIds).some((ids) => ids.length > 1);

  return { columnDefs: updatedColumnDefs, hasDuplicate };
}
